module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/PenAndRuller-1acf230ba474cf135700535e4216e8f3.svg";